import React, { memo, useState, useCallback } from 'react';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import { useI18n } from '../../i18n';
import ErrorIcon from './icons/ErrorIcon';
import Loader from './Loader';

import S from './style/GenericErrorPage';

const i18nKey = (subKey: TemplateStringsArray): string => `dlv_errorpage_${subKey}`;

const redirect = (url: string): void => {
  if (url) {
    window.location.href = url;
  }
};

interface GenericErrorPageProps {
  title?: string;
  description?: string;
  buttonTitle?: string;
  buttonUrl?: string;
  onClick?: () => void;
  actionButtonTitle?: string;
  actionButtonUrl?: string;
}

function GenericErrorPage({
  title = '',
  description = '',
  buttonTitle = '',
  buttonUrl = '',
  onClick,
  actionButtonTitle,
  actionButtonUrl,
}: GenericErrorPageProps) {
  const i18n = useI18n();

  const [isLoaderVisible, setLoaderVisibility] = useState(false);
  const isActionButtonExist = !!actionButtonTitle && !!actionButtonUrl;

  const btnClickHandler = useCallback(() => {
    setLoaderVisibility(true);
    if (onClick) {
      onClick();
    } else {
      redirect(buttonUrl);
    }
  }, [onClick, buttonUrl]);

  const actionBtnClickHandler = useCallback(() => {
    setLoaderVisibility(true);
    redirect(actionButtonUrl);
  }, [actionButtonUrl]);

  if (isLoaderVisible) {
    return <Loader />;
  }

  return (
    <S.PageContainer>
      <S.Wrapper data-cy="error-page" data-testid="error-page">
        <S.Page pageType="error">
          <ErrorIcon />
          <S.Headline textAlign="center" data-cy="error-title">
            {title || i18n(i18nKey`title`)}
          </S.Headline>
          {description && (
            <S.Paragraph data-cy="error-description" data-testid="error-description">
              {description}
            </S.Paragraph>
          )}
          {isActionButtonExist && (
            <S.ActionButton
              onClick={actionBtnClickHandler}
              data-cy="error-action-button"
              data-testid="error-action-button"
            >
              {actionButtonTitle}
            </S.ActionButton>
          )}
          <ButtonTertiaryDark onClick={btnClickHandler} data-cy="error-button">
            {buttonTitle || i18n(i18nKey`tohome`)}
          </ButtonTertiaryDark>
        </S.Page>
      </S.Wrapper>
    </S.PageContainer>
  );
}

export default memo(GenericErrorPage);
